import {
  COMMUNITY_ROLES_FETCH_FAILURE,
  COMMUNITY_ROLES_FETCH_REQUEST,
  COMMUNITY_ROLES_FETCH_SUCCESS,
  COMMUNITY_ROLES_UPDATE_FAILURE,
  COMMUNITY_ROLES_UPDATE_REQUEST,
  COMMUNITY_ROLES_UPDATE_SUCCESS,
} from '../../types';
import { ICommunityRolesState } from '../../types/communityRoles';

const initialState: ICommunityRolesState = {
  loading: false,
  error: null,
  enrollments: [],
  updatingUserId: null,
  communityIdentifier: undefined,
};

export default function communityRolesReducer(state = initialState, action: any): ICommunityRolesState {
  switch (action.type) {
    case COMMUNITY_ROLES_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case COMMUNITY_ROLES_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        enrollments: action.payload?.enrollments || [],
        communityIdentifier: action.payload?.communityIdentifier,
        error: null,
      };
    case COMMUNITY_ROLES_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || 'Failed to load community enrollments',
      };
    case COMMUNITY_ROLES_UPDATE_REQUEST:
      return {
        ...state,
        updatingUserId: action.payload?.userId || null,
        error: null,
      };
    case COMMUNITY_ROLES_UPDATE_SUCCESS:
      return {
        ...state,
        updatingUserId: null,
        enrollments: state.enrollments.map((enrollment) =>
          enrollment.userId === action.payload?.userId
            ? {
                ...enrollment,
                visibleChannelIds: action.payload?.visibleChannelIds || [],
                moderatedChannels: action.payload?.moderatedChannels || [],
                ...(action.payload?.role
                  ? { role: action.payload.role }
                  : {}),
              }
            : enrollment
        ),
      };
    case COMMUNITY_ROLES_UPDATE_FAILURE:
      return {
        ...state,
        updatingUserId: null,
        error: action.payload?.error || 'Failed to update community member access',
      };
    default:
      return state;
  }
}
